import { render, staticRenderFns } from "./NewChatTabs.vue?vue&type=template&id=4d0a49ba&scoped=true"
import script from "./NewChatTabs.vue?vue&type=script&lang=js"
export * from "./NewChatTabs.vue?vue&type=script&lang=js"
import style0 from "./NewChatTabs.vue?vue&type=style&index=0&id=4d0a49ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a49ba",
  null
  
)

export default component.exports